<template>
    <div>
        <div class="content-header">
            <div>
                <h2 class="content-title card-title">Update Permission</h2>
            </div>
        </div>
        <a-card v-if="permission">
            <a-form :form="form"  @submit="handleSubmit">
                <a-row :gutter="16">
                    <a-col class="gutter-row" :span="12">
                        <a-form-item label="Name">
                            <a-input size="large"
                                v-decorator="['name', { rules: [{ required: true, message: 'Please enter name' }],
                                    initialValue: permission.name }]"
                                placeholder="Enter name"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>

                <a-form-item >
                    <a-button type="primary" size="large" class="btn btn-xs" html-type="submit">
                        Update Permission
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>
        <a-card v-else>
            <h4>Permission not find</h4>
        </a-card>
    </div>
</template>

<script>
import { alertPop } from "../../../script/helper";
    import { UPDATE_PERMISSION, GET_PERMISSIONS } from "../../../script/api";
    import { postData, getData } from "../../../script/api-service";

export default {
    props: ['permissionId'],
    data() {
        return {
            permission: null,
        };
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault();

            this.form.validateFields(async (err, values) => {
                if (!err) {
                    let data = {};
                    if (this.permission.name !== values.name) data.name = values.name;

                    if (Object.keys(data).length) {
                        data.permission_id = this.permissionId;

                        let res = await postData(UPDATE_PERMISSION,  data);
                        if (res) {
                            alertPop("success", "Permission Updated Successfully");
                        }
                    } else {
                        alertPop('warning', 'No change found');
                    }
                }
            });
        },
        async getPermissions() {
            let res = await getData(GET_PERMISSIONS);

            if (res) {
                let masterData = res.data?.data;
                this.permission = masterData.find(e => e.id == this.permissionId);
            }
        },
    },
    beforeCreate() {
        this.form = this.$form.createForm(this, { name: "create_permission" });
    },
    mounted() {
        this.getPermissions();
    },
};
</script>